/* eslint-disable import/prefer-default-export */
import { coOwnersAddressNameFields } from 'constants/enums/people';
import foreignCoOwnerItemValidator from 'forms/sections/foreign/activities/shared/foreignCoOwner';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { ForeignActivitiesCoOwnersModel } from './foreignActivitiesCoOwner';

// TODO: Move.
const foreignCoOwnersModel: ValidateJSModel<ForeignActivitiesCoOwnersModel> = {
  List: (value, attributes, attributeName, options) => {
    let additionalValidation: any = {};
    const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options.peopleWhoKnowYou, coOwnersAddressNameFields);
    if (errors.length > 0) {
      additionalValidation = {
        requireTrue: { // force error message; value will never be true
          message: 'relationships.relatives.error.duplicateListItems',
        }
      };
    }

    return {
      ...additionalValidation,
      presence: true,
      branchCollection: { validator: foreignCoOwnerItemValidator },
    };
  },
};

export default foreignCoOwnersModel;
